import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'

export default class PhoneNumber extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    field: PropTypes.object
  }

  state = {valid: true}

  validation(number) {
    const re = /^\d{9}$/
    return re.test(number)
  }

  getNumber(event) {
    if (this.validation(event)) {
      this.setState({valid: true})
    } else {
      this.setState({valid: false})
    }
    this.props.onChange(event)
  }

  messageField() {
    if (!this.state.valid) {
      return 'Campo sin datos o con datos incorrectos para el número. Ej: (95430xxxx)'
    } else {
      return 'Todo se ve bien'
    }
  }

  render() {
    return (
      <Tooltip content={this.messageField()}>
        <div className={styles.osInputContainer}>
          <input
            type="text"
            className={this.state.valid ? styles.osInputText : styles.osInputTextW}
            placeholder={'Teléfono o celular'}
            value={this.props.value ? this.props.value : ''}
            onChange={event => this.getNumber(event.target.value)}
          />
        </div>
      </Tooltip>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/fields/PhoneNumber/index.js